import { RouteLocationNamedRaw } from 'vue-router'

import router from '@/app/router'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { Optional } from '@/shared/utils/optional'

export const optionalPush = async (v: RouteLocationNamedRaw | undefined) => {
  await Optional
    .ofNullable(v)
    .ifPresentAsync(async (route: RouteLocationNamedRaw) => {
      if (route.name === pathNames.CHAT && !resolveChatMessagingUiEnabled()) {
        return
      }
      await router.push(route)
    })
}
